import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";
import {CookieConsentHelper} from "../../helpers/cookie-consent.helper";
import {Module} from "../../models/module.model";

@Component({
  selector: 'app-modules-list',
  templateUrl: './modules-list.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modules-list.component.less']
})
export class ModulesListComponent implements OnInit {
  global_texts: any = null;
  page_texts: any = null;
  modules: Module[] = [];

  constructor(
    public app: AppComponent,
    public cookieConsentHelper: CookieConsentHelper,
  ) {
  }

  async tracking() {
    const trackingConsent = await this.cookieConsentHelper.getTrackingConsent();
    console.log("trackingConsent", trackingConsent);
    this.cookieConsentHelper.trackingConsent(trackingConsent);
  }

  ngOnInit(): void {
    // if session token exists and it is not expired
    if(this.app.apiService.getAutentication()) this.tracking();
    // Delay initialization of the component to allow consent check
    setTimeout(() => {
      this.initializeComponent();
    }, 1000);
  }

  initializeComponent() {
    this.modules = [];

    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;
      this.page_texts = texts.modules_list_page;

      // Get all modules from the server
      this.app.sharedHelper.getModulesData().subscribe((resp_all_modules: any) => {
        console.log("getModulesData resp_all_modules => ", resp_all_modules);
        this.modules = resp_all_modules.data;
      });
    });
  }
}
